// extracted by mini-css-extract-plugin
export default {"incomeSource":"ScreeningOverviewEmploymentIncomeVerificationSourceStepTable_incomeSource__-3YJ9"};